export default __webpack_public_path__ + "static/media/new-graphic-v2.cb03040e.png";